import { customerSearchColumns, groupColumns, regionColumns, vatTuSearchColumns } from '@/constants/search-columns';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { Group, KhachHang, KhuVuc, VatTu } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

interface DetailsTabProps {
  searchFieldStates: {
    customer: KhachHang | null;
    setCustomer: (customer: KhachHang | null) => void;
    customerGroup1: Group | null;
    setCustomerGroup1: (group: Group | null) => void;
    customerGroup2: Group | null;
    setCustomerGroup2: (group: Group | null) => void;
    customerGroup3: Group | null;
    setCustomerGroup3: (group: Group | null) => void;
    region: KhuVuc | null;
    setRegion: (region: KhuVuc | null) => void;
    vatTu: VatTu | null;
    setVatTu: (vatTu: VatTu | null) => void;
    vatTuGroup1: Group | null;
    setVatTuGroup1: (group: Group | null) => void;
    vatTuGroup2: Group | null;
    setVatTuGroup2: (group: Group | null) => void;
    vatTuGroup3: Group | null;
    setVatTuGroup3: (group: Group | null) => void;
  };
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='h-[360px] w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        {/* Mã khách hàng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
          <SearchField<KhachHang>
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={customerSearchColumns}
            dialogTitle='Danh mục khách hàng'
            value={searchFieldStates.customer?.customer_code || ''}
            onRowSelection={searchFieldStates.setCustomer}
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm khách hàng:</Label>
          <div className='flex-1'>
            <div className='flex gap-3'>
              <SearchField<Group>
                type='text'
                columnDisplay='ma_nhom'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC1`}
                searchColumns={groupColumns}
                dialogTitle='Danh mục nhóm khách hàng 1'
                value={searchFieldStates.customerGroup1?.ma_nhom || ''}
                onRowSelection={searchFieldStates.setCustomerGroup1}
              />
              <SearchField<Group>
                type='text'
                columnDisplay='ma_nhom'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC2`}
                searchColumns={groupColumns}
                dialogTitle='Danh mục nhóm khách hàng 2'
                value={searchFieldStates.customerGroup2?.ma_nhom || ''}
                onRowSelection={searchFieldStates.setCustomerGroup2}
              />
              <SearchField<Group>
                type='text'
                columnDisplay='ma_nhom'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC3`}
                searchColumns={groupColumns}
                dialogTitle='Danh mục nhóm khách hàng 3'
                value={searchFieldStates.customerGroup3?.ma_nhom || ''}
                onRowSelection={searchFieldStates.setCustomerGroup3}
              />
            </div>
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Khu vực:</Label>
          <SearchField<KhuVuc>
            type='text'
            displayRelatedField='rgname'
            columnDisplay='rg_code'
            searchEndpoint={`/${QUERY_KEYS.KHU_VUC}`}
            searchColumns={regionColumns}
            dialogTitle='Danh mục khu vực'
            value={searchFieldStates.region?.rg_code || ''}
            onRowSelection={searchFieldStates.setRegion}
          />
        </div>
        <div className='flex w-full items-center'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Mã vật tư:</Label>
            <SearchField<VatTu>
              columnDisplay='ma_vt'
              searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
              searchColumns={vatTuSearchColumns}
              dialogTitle='Danh mục vật tư'
              value={searchFieldStates.vatTu?.ma_vt || ''}
              onRowSelection={searchFieldStates.setVatTu}
            />
          </div>
          <div className='ml-5 whitespace-nowrap'>
            <FormField name='trackInventory' type='checkbox' label='Chỉ xem vật tư có theo dõi tồn kho' />
          </div>
        </div>
        <div className='flex items-center pt-1'>
          <Label className='w-40 min-w-40'>Nhóm vật tư:</Label>
          <div className='flex-1'>
            <div className='flex gap-3'>
              <SearchField<Group>
                type='text'
                columnDisplay='ma_nhom'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=VT1`}
                searchColumns={groupColumns}
                dialogTitle='Danh mục nhóm vật tư 1'
                value={searchFieldStates.vatTuGroup1?.ma_nhom || ''}
                onRowSelection={searchFieldStates.setVatTuGroup1}
              />
              <SearchField<Group>
                type='text'
                columnDisplay='ma_nhom'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=VT2`}
                searchColumns={groupColumns}
                dialogTitle='Danh mục nhóm vật tư 2'
                value={searchFieldStates.vatTuGroup2?.ma_nhom || ''}
                onRowSelection={searchFieldStates.setVatTuGroup2}
              />
              <SearchField<Group>
                type='text'
                columnDisplay='ma_nhom'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=VT3`}
                searchColumns={groupColumns}
                dialogTitle='Danh mục nhóm vật tư 3'
                value={searchFieldStates.vatTuGroup3?.ma_nhom || ''}
                onRowSelection={searchFieldStates.setVatTuGroup3}
              />
            </div>
          </div>
        </div>
        <div className='flex items-center gap-1'>
          <div className='flex-1'>
            <div className='flex gap-1'>
              <FormField
                name='balance'
                label='Số dư'
                labelClassName='w-40'
                type='select'
                options={[
                  { value: '0', label: '0. Tất cả' },
                  { value: '1', label: '1. Chỉ có hóa đơn số dư lớn hơn 0' },
                  { value: '2', label: '2. Chỉ những hóa đơn đã tất toán' }
                ]}
                className='w-[400px]'
                defaultValue={'0'}
              />
            </div>
          </div>
        </div>
        <div className='flex items-center gap-1'>
          <div className='flex-1'>
            <div className='flex gap-1'>
              <FormField
                name='details_collection'
                label='Chi tiết thu tiền'
                labelClassName='w-40'
                type='select'
                options={[
                  { value: '0', label: '0. Không' },
                  { value: '1', label: '1. Có' }
                ]}
                className='w-[400px]'
                defaultValue={'1'}
              />
            </div>
          </div>
        </div>
        <div className='flex items-center gap-1'>
          <div className='flex-1'>
            <div className='flex gap-1'>
              <FormField
                name='reportTemplate'
                label='Mẫu báo cáo'
                labelClassName='w-40'
                type='select'
                options={[
                  { value: 'TC', label: 'Mẫu tiền chuẩn' },
                  { value: 'NT', label: 'Mẫu ngoại tệ' }
                ]}
                className='w-[400px]'
                defaultValue={'TC'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
